<template>
  <div class="tourist">
    <Header></Header>
    <Nav type="3" @getNavID="getNavID"></Nav>
    <Toptitle title="旅游攻略"></Toptitle>
    <div class="banner">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="(slide,index) in swiperSlides" :key="index">
          <div class="swiper_img" @click="goBannerDetail(slide.paperid,slide.url)">
            <img :src="slide.picture" alt="">
            <span></span>
            <p>{{slide.title}}</p>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev" slot="button-prev">

        </div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
    <div class="tourism_theme">
      <div class="tourism_theme_tit">驿道主题推荐</div>
      <swiper :options="tourismOption" ref="mySwiper" class="tourismOption4Show">
        <swiper-slide v-for="(slide,index) in tourismSlides" :key="index">
          <div class="tourism_img">
            <img :src='slide.picture' @click="goTopicMore(index,slide.id)">
          </div>
          <p>{{slide.name}}</p>
        </swiper-slide>
        <div class="swiper-button-prev tourism_prev" slot="button-prev"></div>
        <div class="swiper-button-next tourism_next" slot="button-next"></div>
      </swiper>

      <swiper :options="tourismOption3" ref="mySwiper" class="tourismOption3Show">
        <swiper-slide v-for="(slide,index) in tourismSlides" :key="index">
          <div class="tourism_img">
            <img :src='slide.picture' @click="goTopicMore(index,slide.id)">
          </div>
          <p>{{slide.name}}</p>
        </swiper-slide>
        <div class="swiper-button-prev tourism_prev" slot="button-prev"></div>
        <div class="swiper-button-next tourism_next" slot="button-next"></div>
      </swiper>

      <swiper :options="tourismOption2" ref="mySwiper" class="tourismOption2Show">
        <swiper-slide v-for="(slide,index) in tourismSlides" :key="index">
          <div class="tourism_img">
            <img :src='slide.picture' @click="goTopicMore(index,slide.id)">
          </div>
          <p>{{slide.name}}</p>
        </swiper-slide>
        <div class="swiper-button-prev tourism_prev" slot="button-prev"></div>
        <div class="swiper-button-next tourism_next" slot="button-next"></div>
      </swiper>
    </div>
    <div class="tourism_guide">
      <div class="tourism_guide_left" v-if="ALLYiDao.length>0">
        <img :src="ALLYiDao[imgIndex].picture">
        <span></span>
        <p>{{ALLYiDao[imgIndex].name}}</p>
      </div>
      <div class="tourism_guide_right">
        <p class="tourism_guide_tit">旅游指南</p>
        <div class="tourism_guide_list">
          <a v-for="(item,index) of ALLYiDao" :key="index" @click="goTouristGuide(item.id,item.name,index)" @mouseover="chooseImg(index)">{{item.name}}旅游指南</a>
        </div>
      </div>
    </div>
    <div class="tourism_strategic">
      <p class="tourism_strategic_tit">驿道旅游攻略推荐</p>
      <div class="tourism_strategic_list">
        <div class="tourism_strategic_item" v-for="(item,index) of YiDaoStrategyList" :key='index' @click="goArticleDetail(item.id)">
          <div class="tourism_strategic_item_img">
            <img :src="item.picture">
          </div>
          <span class="">{{item.title}}</span>
          <p>
            <span>
              {{item.subtitle}}
            </span>
          </p>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './common/Header.vue'
  import Nav from './common/Nav.vue'
  import Footer from './common/Footer.vue'
  import 'swiper/dist/css/swiper.css'
  import {
    swiper,
    swiperSlide
  } from 'vue-awesome-swiper'
  import {
    request
  } from 'http';
  import Toptitle from './common/Toptitle.vue'
  export default {
    data() {
      return {
        swiperOption: {
          notNextTick: true,
          // autoplay: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        },
        swiperSlides: [],
        tourismOption: {
          slidesPerView: 4,
          spaceBetween: 17,
          // slidesPerGroup: 4,
          loopFillGroupWithBlank: true,
          navigation: {
            nextEl: '.tourism_prev',
            prevEl: '.tourism_next'
          },
          observer: true, //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, //修改swiper的父元素时，自动初始化swiper
          observeSlideChildren: true
        },
        tourismOption3: {
          slidesPerView: 3,
          spaceBetween: 17,
          // slidesPerGroup: 4,
          loopFillGroupWithBlank: true,
          navigation: {
            nextEl: '.tourism_prev',
            prevEl: '.tourism_next'
          },
          observer: true, //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, //修改swiper的父元素时，自动初始化swiper
          observeSlideChildren: true
        },
        tourismOption2: {
          slidesPerView: 2,
          spaceBetween: 17,
          // slidesPerGroup: 4,
          loopFillGroupWithBlank: true,
          navigation: {
            nextEl: '.tourism_prev',
            prevEl: '.tourism_next'
          },
          observer: true, //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, //修改swiper的父元素时，自动初始化swiper
          observeSlideChildren: true
        },
        tourismSlides: [],
        screenWidth: '',
        navID: '',
        strategyJson: {
          type: 6,
          targetid: '',
          pageSize: 999,
          pageNo: 1,
        },
        YiDaoStrategyList: [],
        ALLYiDao: [],
        imgIndex:0,
      }
    },
    components: {
      Header,
      Footer,
      Nav,
      swiper,
      swiperSlide,
      Toptitle
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    methods: {
      getAllThemes() {
        this.axios.post('/api/index/getAllThemes.do', this.qs(null)).then(res => {
          if (res.status == 200) {
            this.tourismSlides = res.data
          }
        })
      },
      getBanners() {
        this.axios.post('api/b_bannermag/getListByNavId.do', this.qs({
          navigateid: this.navID
        })).then(res => {
          if (res.status == 200) {
            this.swiperSlides = res.data.data
          }
        })
      },
      getYiDaoStrategy() {
        this.axios.post('/api/index/getArticleList.do', this.qs(this.strategyJson)).then(res => {
          if (res.status == 200) {
            this.YiDaoStrategyList = res.data.results
          }
        })
      },
      getAllYiDao() {
        this.axios.post('api/l_yidaoinfo/getAll.do', this.qs(null)).then(res => {
          if (res.status == 200) {
            this.ALLYiDao = res.data.data
          }
        })
      },
      goArticleDetail(id) {
        this.$router.push({
          name: 'articleDetail',
          query: {
            id: id
          }
        })
      },
      goTopicMore(index, id) {
        this.$router.push({
          name: 'topicMore',
          query: {
            index: index,
            themeID: id
          }
        })
      },
      goTouristGuide(id, name,index) {
        this.$router.push({
          name: 'touristGuide',
          query: {
            targetid: id,
            name: name,
            index:index
          }
        })
      },
      getNavID(data) {
        this.navID = data
        this.getAllThemes()
        this.getBanners()
        this.getYiDaoStrategy()
        this.getAllYiDao()
      },
      goBannerDetail(id, url) {
        if (url != '') {
          window.open(url)
        } else {
          this.$router.push({
            name: 'articleDetail',
            query: {
              id: id
            }
          })
        }

      },
      chooseImg(index){
        this.imgIndex = index
      }
    },
    mounted() {
      this.screenWidth = document.body.clientWidth;
      window.onresize = () => {
        return (() => {
          this.screenWidth = document.body.clientWidth;
        })();
      }
      if (this.$route.query.navID) {
        this.navID = this.$route.query.navID
        this.getAllThemes()
        this.getBanners()
        this.getYiDaoStrategy()
        this.getAllYiDao()
      }
    },
    watch: {
      'screenWidth': function(newVal, oldVal) {}
    }
  }
</script>

<style>
</style>
